import React from "react";
import EditJob from "../components/edit/EditJob";

const Jobs = () => {
  return (
    <div>
      <EditJob />
    </div>
  );
};

export default Jobs;
